import { FC } from 'react';
import { Navigate, NavigateProps, useLocation } from 'react-router-dom';

export const NavigateWithSearch: FC<NavigateProps> = ({ to, ...props }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} {...props} />;
};
